import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IconModule } from '@zipari/design-system';
import { WorkflowNavComponent } from './workflow-nav.component';
import { NavigationModule } from '../navigation/navigation.module';

@NgModule({
  imports: [CommonModule, RouterModule, NavigationModule, IconModule],
  declarations: [WorkflowNavComponent],
  exports: [WorkflowNavComponent],
})
export class WorkflowNavModule {}
